import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { CdkPortal } from '@angular/cdk/portal'
import { Overlay, OverlayConfig, OverlayRef, PositionStrategy } from '@angular/cdk/overlay'

@Component({
    selector: 'app-side-panel',
    templateUrl: './side-panel.component.html',
    styleUrls: ['./side-panel.component.scss'],
})
export class SidePanelComponent {
    @ViewChild(CdkPortal) private layerOverlayTemplate!: CdkPortal
    private layerOverlay: OverlayRef | null = null
    private _visible = false
    private positionInternal = PanelPosition.Right
    tabOverlayOpen = false
    tabEntries = Object.entries(Tabs).map(([key, value]) => ({ key, value }))

    @Input() currentTab: Tabs

    @Input()
    set visible(value: boolean) {
        this._visible = value
    }

    get visible(): boolean {
        return this._visible
    }

    @Input()
    set position(position: string) {
        if (position.toLowerCase() === 'right') {
            this.positionInternal = PanelPosition.Right
        }
        if (position.toLowerCase() === 'left') {
            this.positionInternal = PanelPosition.Left
        }
    }

    @Output()
    readonly panelToggled = new EventEmitter<boolean>()

    @Output()
    readonly tabChangeRequested = new EventEmitter<string>()

    get isRight(): boolean {
        return this.positionInternal === PanelPosition.Right
    }

    constructor(private readonly overlay: Overlay) {}

    togglePanel(): void {
        this.visible = !this.visible
        this.panelToggled.emit(this.visible)
        this.layerOverlay?.detach()
    }

    showTabContent(entry: string): void {
        this.tabChangeRequested.emit(entry)
        this.visible = true
        this.tabOverlayOpen = false
        this.layerOverlay?.detach()
    }

    openTabOverlay(element: MouseEvent): void {
        this.tabOverlayOpen = !this.tabOverlayOpen
        if (!this.layerOverlay) {
            this.layerOverlay = this.overlay.create(
                new OverlayConfig({
                    positionStrategy: this.createPositionStrategy(element.target as HTMLElement),
                })
            )
        }
        this.tabOverlayOpen
            ? this.layerOverlay?.attach(this.layerOverlayTemplate)
            : this.layerOverlay?.detach()
    }

    private createPositionStrategy(element: HTMLElement): PositionStrategy {
        return this.overlay
            .position()
            .flexibleConnectedTo(element)
            .withPush(true)
            .withPositions([
                {
                    originX: 'start',
                    originY: 'top',
                    overlayX: 'end',
                    overlayY: 'top',
                },
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'end',
                    overlayY: 'bottom',
                },
            ])
    }
}

enum PanelPosition {
    Left,
    Right,
}

export enum Tabs {
    GATING = 'Manual gating',
    HIERARCHICAL_GATING = 'Hierarchical gating',
    RECURRENT_NEIGHBORHOODS = 'Recurrent neighborhoods',
    NEIGHBORHOOD_ENRICHMENT = 'Neighborhood enrichment',
    // CELL_TYPE_DETECTION = 'Cell type detection',
    AUTO_CELL_TYPE_DETECTION = 'Auto cell type detection',
    PLOTTING = 'Plotting',
}
